( function( app ) {
  const COMPONENT = {
    init: function() {
      const openFirstChildMenu = function( panel ) {
        const $panel = $( panel );
        const $firstTrigger = $panel.find( '.primary-menu-first__default-open' ).first();

        if ( $firstTrigger.length && !$firstTrigger.hasClass( 'is-open' ) ) {
          $firstTrigger.trigger( 'click' );
        }
      };

      const resetDesktopPanelScroll = function( panel ) {
        panel.style.height = '';
        panel.style.maxHeight = '';
        panel.style.overflowY = '';
      };

      const updateDesktopPanelScroll = function( panel ) {
        if ( !window.matchMedia( '(min-width: 1024px)' ).matches ) {
          resetDesktopPanelScroll( panel );
          return;
        }

        resetDesktopPanelScroll( panel );

        const panelTop = panel.getBoundingClientRect().top;
        const availableHeight = Math.max( window.innerHeight - panelTop, 0 );
        const naturalHeight = panel.scrollHeight;

        if ( naturalHeight > availableHeight ) {
          panel.style.maxHeight = `${availableHeight}px`;
          panel.style.overflowY = 'auto';
        }
      };

      const updateOpenDesktopPanels = function() {
        $( '.navigation-one .primary-menu-item__menu.is-open' ).each( function() {
          updateDesktopPanelScroll( this );
        } );
      };

      if ( $( window ).width() >= 1024 ) {
        // ADA close menu when focus shifts outside of it
        $( '.navigation-one .primary-navigation__panels' ).on( 'focusout', function( e ) {
          const $menuItem = $( this );
          const newFocus = e.relatedTarget;
          if ( newFocus === null ) return;
          if ( !$menuItem.has( newFocus ).length ) {
            const $trigger = $menuItem.find( '.primary-menu-item__link.is-open' );
            if ( $trigger.length ) {
              $trigger.trigger( 'click' );
              newFocus.focus();
            }
          }
        } );

        // on desktop, open the first menu on each dropdown panel
        $( '.navigation-one .primary-menu-item__menu' ).each( function() {
          openFirstChildMenu( this );
        } );

        $( '.navigation-one .primary-menu-item__menu' ).on( 'toggleAfter', function() {
          if ( $( this ).hasClass( 'is-open' ) ) {
            openFirstChildMenu( this );
            setTimeout( () => updateDesktopPanelScroll( this ), 200 );
          } else {
            resetDesktopPanelScroll( this );
          }
        } );

        $( window ).on( 'resize', updateOpenDesktopPanels );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'navigation-one', COMPONENT );
} )( app );
